import React, { useState, useEffect, useContext } from "react";
import "./State.css";
import axios from "axios";
import AddInstallment from "./AddInstallment";
import EditInstallment from "./EditInstallment";
import { toast } from "react-toastify";
import { AuthContext } from "../../Context/AuthContext";
import Preloader from "../../shared/PreLoaders";

const ManageInstallment = () => {
  const [installments, setInstallments] = useState([]);
  const [showAddPopup, setShowAddPopup] = useState(false);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [currentInstallment, setCurrentInstallment] = useState(null);
  const { permissions } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    setLoading(true);
    const fetchInstallments = async () => {
      try {
        const response = await axios.get(`${Api}/api/installments`);
        setInstallments(response.data);
      } catch (err) {
        console.error("Error fetching data", err);
      }
      setLoading(false);
    };

    fetchInstallments();
  }, []);

  const handleShowAddPopup = () => {
    setShowAddPopup(true);
  };

  const handleCloseAddPopup = () => {
    setShowAddPopup(false);
  };

  const handleShowEditPopup = (installment) => {
    setCurrentInstallment(installment);
    setShowEditPopup(true);
  };

  const handleCloseEditPopup = () => {
    setShowEditPopup(false);
    setCurrentInstallment(null);
  };

  const handleDeleteInstallment = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this Installments?"
    );
    if (!confirmDelete) {
      return;
    }
    try {
      await axios.delete(`${Api}/api/installment/${id}`);
      setInstallments(
        installments.filter((installment) => installment._id !== id)
      );
      toast.success("Deleted Successfully");
    } catch (err) {
      console.error("Error deleting installment", err);
    }
  };

  const handleAddInstallment = (newInstallment) => {
    setInstallments([...installments, newInstallment]);
  };

  return (
    <div>
      <Preloader loading={loading} />
      <div className="page-header">
        <h3 className="page-title"> Installments </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="!#" onClick={(event) => event.preventDefault()}>
                VFC
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Installments
            </li>
          </ol>
        </nav>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="row icons-list">
            {permissions.includes("AddInstallment") && (
              <div className="Add_btn">
                <button
                  type="button"
                  className="btn btn-inverse-success"
                  onClick={handleShowAddPopup}
                >
                  Create New
                </button>
              </div>
            )}
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr className="table table-hover">
                    <th>
                      <span>SI.No</span>
                    </th>
                    <th>
                      <span>Installment Name</span>
                    </th>
                    <th>
                      <span>Installment Number</span>
                    </th>
                    {permissions.includes("EditInstallment") &&
                      permissions.includes("DeleteInstallment") && (
                        <th>
                          <span>Actions</span>
                        </th>
                      )}
                  </tr>
                </thead>
                <tbody>
                  {installments.map((item, index) => (
                    <tr key={item._id}>
                      <td>{index + 1}</td>
                      <td>{item.installmentName}</td>
                      <td>{item.installmentNumber}</td>
                      {permissions.includes("EditInstallment") &&
                        permissions.includes("DeleteInstallment") && (
                          <td>
                            <i
                              className="mdi mdi-pen"
                              style={{ fontSize: "1.5rem", cursor: "pointer" }}
                              onClick={() => handleShowEditPopup(item)}
                            />

                            <i
                              className="mdi mdi-delete"
                              style={{ fontSize: "1.5rem", cursor: "pointer" }}
                              onClick={() => handleDeleteInstallment(item._id)}
                            />
                          </td>
                        )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {showAddPopup && (
        <AddInstallment
          onClose={handleCloseAddPopup}
          onAddInstallment={handleAddInstallment}
        />
      )}
      {showEditPopup && currentInstallment && (
        <EditInstallment
          installment={currentInstallment}
          onClose={handleCloseEditPopup}
        />
      )}
    </div>
  );
};

export default ManageInstallment;
